import { useEffect, useState } from 'react';

import { learningPathApi } from '../api';
import type { UserMetaDataResponse } from '../types';

export function usePublicProfile(learnerID: string | undefined) {
  const [userInfo, setUserInfo] = useState<Partial<UserMetaDataResponse>>({});
  const [userInfoLoaded, setUserInfoLoaded] = useState<boolean>(false);

  const successCB = (data: UserMetaDataResponse) => {
    setUserInfo(data);
    setUserInfoLoaded(true);
  };

  const errorCB = () => {
    setUserInfo({});
    setUserInfoLoaded(true);
  };

  useEffect(() => {
    if (!learnerID || userInfoLoaded) {
      return;
    }
    learningPathApi.getPublicProfile(learnerID, successCB, errorCB);
  }, [learnerID]);

  return {
    userInfo,
    userInfoLoaded,
  };
}
